import * as React from 'react';
import { ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { PageWidget } from './PageWidget';
import { JourneyParams, resolveRouteItems, Routes, useJourneyNavigation } from '../../routes';
import { ProfileSidebarItems } from '../../pages/profile/ProfileLandingPage';
import { ButtonType, ButtonWidget } from '../buttons/ButtonWidget';
import { styled } from '../../theme';
import { useSystem } from '../../hooks/useSystem';
import { observer } from 'mobx-react';

export interface SmartPageWidgetProps {
  activeItemKey?: string;
  children?: ReactNode;
  loading?: boolean;
}

export const ProfilePageWidget: React.FC<SmartPageWidgetProps> = observer((props) => {
  const params = useParams() as JourneyParams;
  const system = useSystem();
  const { navigate } = useJourneyNavigation(Routes.PROFILE_HOME);
  return (
    <PageWidget
      loading={props.loading}
      title={
        <S.TitleContainer>
          <ButtonWidget
            type={ButtonType.SECONDARY}
            icon={'arrow-left'}
            label="Back to organization"
            action={() => {
              navigate(Routes.ADMIN_HOME, { org_id: system.context.USER_ORG! });
            }}
          />
          <S.Title>Profile</S.Title>
        </S.TitleContainer>
      }
      {...props}
      items={resolveRouteItems(ProfileSidebarItems, params)}
    >
      {props.children}
    </PageWidget>
  );
});

namespace S {
  export const Title = styled.div`
    color: ${(p) => p.theme.header.color};
    padding-left: 20px;
  `;
  export const TitleContainer = styled.div`
    display: flex;
    align-items: center;
    flex-grow: 1;
    padding-left: 20px;
  `;
}
